module.exports = __webpack_public_path__ + "static/media/silver.cadfa13c.svg";